import { getMapboxAccessToken } from '@/utils/urls';

type Coordinates = {
  latitude: number;
  longitude: number;
};

const parseCoordinate = (value: string | number | null | undefined) => {
  if (value == null) return null;

  const parsed = typeof value === 'string' ? parseFloat(value) : value;

  if (typeof parsed !== 'number' || isNaN(parsed) || parsed === 0) {
    return null;
  }

  return parsed;
};

const formatDurationAsEtaTime = (
  durationSeconds: number,
  dateLocale: string
) => {
  const etaDate = new Date(Date.now() + durationSeconds * 1000);

  return etaDate.toLocaleTimeString(dateLocale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

const fetchMapboxDrivingDuration = async (
  origin: Coordinates,
  destination: Coordinates,
  signal?: AbortSignal
): Promise<number | null> => {
  const accessToken = getMapboxAccessToken();

  if (!accessToken) {
    return null;
  }

  const coordinates = `${origin.longitude},${origin.latitude};${destination.longitude},${destination.latitude}`;
  const url = new URL(
    `https://api.mapbox.com/directions/v5/mapbox/driving/${coordinates}`
  );
  url.searchParams.set('overview', 'false');
  url.searchParams.set('access_token', accessToken);

  const response = await fetch(url.toString(), { signal });

  if (!response.ok) {
    return null;
  }

  const data = (await response.json()) as {
    routes?: Array<{ duration?: number }>;
  };

  const duration = data.routes?.[0]?.duration;

  if (
    typeof duration !== 'number' ||
    !Number.isFinite(duration) ||
    duration <= 0
  ) {
    return null;
  }

  return duration;
};

export { fetchMapboxDrivingDuration, formatDurationAsEtaTime, parseCoordinate };

export type { Coordinates };
